/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type EnumPatientContactType = "email" | "fax" | "inapp" | "sms" | "voice" | "whatsapp" | "%future added value";
export type TableRowReminder_Reminder = {
    readonly _id: string;
    readonly sendAt: unknown | null;
    readonly patient: {
        readonly _id: string;
        readonly name: string | null;
        readonly contact: ReadonlyArray<{
            readonly active: boolean | null;
            readonly type: EnumPatientContactType | null;
            readonly value: string | null;
        } | null> | null;
        readonly doNotContact: boolean | null;
    } | null;
    readonly appointment: {
        readonly date: unknown | null;
        readonly provider: {
            readonly name: string | null;
        } | null;
    } | null;
    readonly " $fragmentRefs": FragmentRefs<"TypographyReminderType_Reminder" | "IconButtonReminderActions_Reminder">;
    readonly " $refType": "TableRowReminder_Reminder";
};
export type TableRowReminder_Reminder$data = TableRowReminder_Reminder;
export type TableRowReminder_Reminder$key = {
    readonly " $data"?: TableRowReminder_Reminder$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"TableRowReminder_Reminder">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "_id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TableRowReminder_Reminder",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sendAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Patient",
      "kind": "LinkedField",
      "name": "patient",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "PatientContact",
          "kind": "LinkedField",
          "name": "contact",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "active",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "type",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "value",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "doNotContact",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Appointment",
      "kind": "LinkedField",
      "name": "appointment",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "date",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Provider",
          "kind": "LinkedField",
          "name": "provider",
          "plural": false,
          "selections": [
            (v1/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TypographyReminderType_Reminder"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "IconButtonReminderActions_Reminder"
    }
  ],
  "type": "Reminder",
  "abstractKey": null
};
})();
(node as any).hash = '1c925808cdd4ec8cbf5ebb416bd769a8';
export default node;
